import { Capacitor } from "@capacitor/core";

// Одна кодовая база работает и в браузере, и внутри iOS-приложения.
export const isNativeApp = () => {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
};

export const nativePlatform = () => {
  try {
    return Capacitor.getPlatform();   // "ios" | "android" | "web"
  } catch {
    return "web";
  }
};
